import Card from 'react-bootstrap/Card'
import Table from 'react-bootstrap/Table'

import { EmptyContainer } from '../EmptyContainer'
import {
  formatCurrency,
  formatInteger,
  formatPercent,
} from './fnbAnalyticsUtils'

export default function FnbAnalyticsItemTable({ items }) {
  return (
    <Card body className="card--md">
      <h2 className="h5 mb-3">Item performance</h2>
      {!items?.length ? (
        <EmptyContainer>
          <p className="mb-0 small text-muted">
            No item snapshot data for this event yet.
          </p>
        </EmptyContainer>
      ) : (
        <div className="table-container border-bottom-0">
          <Table responsive className="mb-0 fnb-analytics-table">
            <thead>
              <tr>
                <th className="text-left uppercase text-body">Item</th>
                <th className="text-right uppercase text-body">Qty sold</th>
                <th className="text-right uppercase text-body">Revenue</th>
                <th className="text-right uppercase text-body">Avg price</th>
                <th className="text-right uppercase text-body">% of sales</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item) => (
                <tr key={item.itemId || item.itemName}>
                  <td className="text-left">{item.itemName}</td>
                  <td className="text-right">
                    {formatInteger(item.quantitySold)}
                  </td>
                  <td className="text-right">
                    {formatCurrency(item.grossRevenue)}
                  </td>
                  <td className="text-right">
                    {formatCurrency(item.avgSellingPrice)}
                  </td>
                  <td className="text-right">
                    {formatPercent(item.percentOfSales)}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
    </Card>
  )
}
